import { useEffect, useState } from "react";
import formatMoney from "../../../utils/formatMoney";
import revenueBySales from "../../../utils/partsdata/revenueBySales";
import { REACT_APP_ARPS_BASE_URL } from "../../../utils/urls";
import RevenueDetails from "./RevenueDetails";
import { Spin } from "antd";

export default function PartsSummary({ startDate, endDate }: any) {
  const [revenues, setRevenues] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState();

  const [showDetails, setShowDetails] = useState(false);

  const fetchRevenues = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/revenue/parts/sales?start=${startDate}&end=${endDate}`
    );
    const data = await response.json();
    setLoading(false);
    const res = revenueBySales(data[0].list);
    setRevenues(res);
  };

  useEffect(() => {
    fetchRevenues();
  }, [startDate]);

  let revTotal = 0;

  revenues.forEach((revenue: any) => {
    if (revenue !== undefined) {
      if (revenue.net !== undefined) {
        revTotal = revTotal + revenue.net;
      }
    }
  });

  return (
    <div className="col-span-12 sm:col-span-4 md:col-span-4">
      <div className="h-full bg-white mb-4 border border-gray-300 rounded-lg px-4">
        <div className="border-b h-16">
          <div className="border-b h-16 flex justify-center items-center">
            <div className="font-bold">Parts Revenue Summary</div>
          </div>
        </div>
        <div className="">
          {loading ? (
            <div className="flex flex-col justify-center items-center flex-1 mt-8">
              <Spin />
            </div>
          ) : (
            <div className="">
              {revenues?.map((revenue: any, index: number) => {
                return (
                  <div key={index}>
                    {revenue?.net !== undefined ? (
                      <button
                        onClick={() => {
                          setShowDetails(true);
                          setSelected(revenue);
                        }}
                        className="flex justify-between items-center py-3 px-2 w-full border-b hover:bg-red-100 cursor-pointer"
                      >
                        <div className="">{revenue?.name}</div>
                        <div className="">{formatMoney(revenue?.net)}</div>
                      </button>
                    ) : null}
                  </div>
                );
              })}
            </div>
          )}
          {loading ? null : (
            <div className="flex justify-between items-center p-4 border-t border-gray-300">
              <div className="">Grand Total</div>
              <div className="font-bold">{formatMoney(revTotal)}</div>
            </div>
          )}
        </div>
      </div>
      <RevenueDetails
        isVisible={showDetails}
        setShowDetails={setShowDetails}
        selected={selected}
        services={revenues}
        startDate={startDate}
        endDate={endDate}
      />
    </div>
  );
}
